"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sanitizeNonNumeric = (locale, value) => locale === 'en'
    ? Number(String(value).replace(/[^0-9.]/g, ''))
    : Number(String(value)
        .replace(/[^0-9,]/g, '')
        .replace(/,/g, '.'));
const formatters = {};
const getFormatter = (locale, withCurrency, precision) => {
    const currencyKey = withCurrency ? 'currency' : 'noCurrency';
    const key = `${locale}-${currencyKey}-${precision}`;
    let formatter = formatters[key];
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale ?? 'de', {
            minimumFractionDigits: precision,
            maximumFractionDigits: precision,
            ...(withCurrency ? { style: 'currency', currency: 'EUR' } : {}),
        });
        formatters[key] = formatter;
    }
    return formatter;
};
// eslint-disable-next-line import/no-unused-modules
function formatMoney(locale, argValue, options = {}) {
    const precision = options?.precision === undefined ? 2 : options?.precision;
    const sanitisedValue = typeof argValue === 'number' ? argValue || 0 : sanitizeNonNumeric(locale, argValue);
    const formatter = getFormatter(locale, !options?.format, precision);
    const result = formatter.format(sanitisedValue);
    return result;
}
exports.default = formatMoney;
//# sourceMappingURL=formatMoney.js.map